import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import React from "react";
import myRestClient from "../common/restClient";
import TranslatedText from "./TranslatedText";
import {
    getUserCompany,
    getUserCompanyRole,
    getPolicies
} from "../common/authClient";
import { POLICY_COMPANIES } from "../common/rolesManagement";
import { PER_PAGE_MAX_LIMIT } from "../config";

const MY_COMPANY_ID = getUserCompany();

class MainCompanySelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            main_sellers: [],
            default_value: 0,
            isMaster: false
        };
    }

    componentDidMount() {
        let id;
        if (this.props.locked_on_login_company) {
            id = MY_COMPANY_ID;
        } else if (this.props.record) {
            id = this.props.record.master_company_id;
        } else {
            id = null;
        }
        const query = { ids: [id] };
        if (query.ids && query.ids.length === 1 && query.ids[0]) {
            myRestClient("GET_MANY", "companies", query).then(
                result => {
                    this.props.input.onChange(result.data[0].id);

                    // If i'm an admin var the only company i want to show in the
                    // select combo is the master company so i put it in directly
                    // without fetching it in the next step
                    let sellers = [];
                    if (
                        getPolicies(getUserCompanyRole()).includes(
                            POLICY_COMPANIES.FILTER_LIMIT_COMPANIES
                        )
                    ) {
                        sellers = [
                            {
                                id: result.data[0].id,
                                name: result.data[0].name
                            }
                        ];
                    }
                    this.setState({
                        default_value: result.data[0].id,
                        main_sellers: sellers
                    });
                },
                error => {
                    return error;
                }
            );
        }
        // I don't fetch the companies main sellers if i'm an admin var
        // Because i set it in the previous step
        if (
            !getPolicies(getUserCompanyRole()).includes(
                POLICY_COMPANIES.FILTER_LIMIT_COMPANIES
            )
        ) {
            const params = {
                filter: { main_seller: true },
                pagination: { page: 1, perPage: PER_PAGE_MAX_LIMIT },
                sort: { field: "name", order: "asc" }
            };
            myRestClient("GET_LIST", "companies", params).then(
                result => {
                    this.setState({ main_sellers: result.data });
                },
                error => {
                    return [];
                }
            );
        }
        const params = {
            pagination: { page: 1, perPage: 10000 },
            sort: { field: "name", order: "asc" }
        };
        myRestClient("GET_LIST", "companies", params).then(
            result => {
                for (let item in result.data) {
                    if (
                        result.data[item].master_company_id ===
                        this.props.record.id
                    ) {
                        this.setState({ isMaster: true });
                        break;
                    }
                }
            },
            error => {
                return error;
            }
        );
    }

    handleChange = event => {
        this.props.input.onChange(event.target.value);
        this.setState({ default_value: event.target.value });
    };

    renderMenuItems = () => {
        const sellers = this.state.main_sellers
            ? this.state.main_sellers.map(param => {
                  return this.props.record &&
                      this.props.record.id !== param.id ? (
                      <MenuItem value={param.id} key={param.id + param.name}>
                          {param.name}
                      </MenuItem>
                  ) : null;
              })
            : [];
        sellers.unshift(
            <MenuItem key={0} value={0}>
                {""}
            </MenuItem>
        );
        return sellers;
    };

    render() {
        // La scelta dell'azienda master deve essere possibile solo se l'azienda selezionata non è già padre
        return !this.state.isMaster ? (
            <FormControl style={{ width: 256 }}>
                <InputLabel htmlFor="master_company_id_select">
                    <TranslatedText resource_name="resources.companies.fields.master_company_id" />
                </InputLabel>
                <Select
                    disabled={getPolicies(getUserCompanyRole()).includes(
                        POLICY_COMPANIES.FILTER_LIMIT_COMPANIES
                    )} // Disabled if im an admin var and passed the locked_on_login_company prop
                    value={this.state.default_value}
                    onChange={this.handleChange}
                    inputProps={{
                        name: "master_company_id",
                        id: "master_company_id_select"
                    }}
                >
                    {this.renderMenuItems()}
                </Select>
            </FormControl>
        ) : null;
    }
}

MainCompanySelect.defaultProps = {
    addField: true
};

export default MainCompanySelect;



// WEBPACK FOOTER //
// ./src/components/MainCompanySelect.js